import { Stack, Typography } from "@mui/material";
import { AnalyticCard } from "./AnalyticCard";
import { useParams } from "react-router-dom";
import { useGetCampaignSummaryQuery } from "../../../api";
import { StackChartBtn } from "../../ui/buttons/BubbleChartBtn/StackChartBtn";

type Props = {
  title: string;
  tooltip: string;
  children: React.ReactNode;
  isRoleChartBtnDisabled?: boolean;
  isProduct?: boolean;
  companyName?: string;
};

export const AnalyticCardWrapper = ({
  title,
  tooltip,
  children,
  isRoleChartBtnDisabled,
  isProduct,
  companyName,
}: Props) => {
  const { campaign_id, account_id } = useParams();

  const { data } = useGetCampaignSummaryQuery(
    {
      campaign_id: campaign_id!,
    },
    { skip: !campaign_id },
  );

  return (
    <AnalyticCard
      isProduct={isProduct}
      flexGrow={1}
      tooltip={tooltip}
      header={
        <Stack flexDirection="row" width="100%" justifyContent="space-between">
          <Typography
            variant="button"
            sx={{
              lineHeight: "20px",
              padding: `8px 0 ${isProduct ? "8px" : "12px"} 0`,
              color: isProduct ? "#1F2932" : "#585858",
            }}
          >
            {title}
          </Typography>
          {title === "Gap Analysis" && (
            <>
              {(campaign_id || account_id) && (
                <>
                  <StackChartBtn
                    id={account_id! || campaign_id!}
                    isAccounts={!account_id}
                    isDisabled={
                      !!isRoleChartBtnDisabled ||
                      data?.total_accounts_analyzed === 0
                    }
                    isNotActiveRole={!!data?.all_key_roles_inactive}
                    title={companyName}
                  />
                </>
              )}
            </>
          )}
        </Stack>
      }
      body={children}
    />
  );
};
